// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1cecs","location":"Header_location__209J7"};